import React from "react";
import { css } from "react-emotion";
import { isMobileDevice } from "helpers";
import Footer from "../Footer";
import Header from "../Header";

const wrapper = css`
  font-size: 2em;
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-top: 50px;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;

  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
  }
`;

const ErrorPage = ({ errorMessage }) => {
  const isMob = isMobileDevice();
  const getTextStyle = (color) => {
    return css`
      color: #000000;
      font-size: 25px;
      margin: 0px;
      text-align: center;
      @media only screen and (min-width: 768px) {
        font-size: 1em;
        padding: 20px 0px;
      }
    `;
  };
  return (
    <div className={wrapper}>
      {!isMob && <Header history={history} />}
      <main
        style={{
          width: "100%",
          minHeight: "100vh",
          backgroundColor: "rgb(255, 255, 255)",
          flex: "1 0 auto",
          textAlign: "center",
          paddingRight: "30px",
          paddingLeft: "30px",
        }}
      >
        <div className={row}>
          <div className={col} style={{ textAlign: "center" }}>
            <h4 className={getTextStyle(null)}>{errorMessage}</h4>
          </div>
        </div>
      </main>
      {!isMob && <Footer />}
    </div>
  );
};

export default ErrorPage;
